<template>
    <div>
        <b-table borderless :fields="bootstrapTable.fields" :items="data">
            <template v-slot:cell(code)="data">
                <span v-text="data.item.data.attributes.code"/>
            </template>

            <template v-slot:cell(client_id)="data">
                <span v-text="data.item.data.attributes.client"/>
            </template>

            <template v-slot:cell(facility)="data">
                <span v-text="data.item.data.attributes.facility"/>
            </template>

            <template v-slot:cell(unit)="data">
                <span v-text="data.item.data.attributes.unit"/>
            </template>

            <template v-slot:cell(move_in)="data">
                <span v-text="data.item.data.attributes.move_in"/>
            </template>

            <template v-slot:cell(updated_by)="data">
                <span v-text="data.item.data.attributes.updated_by"/>
            </template>

            <template v-slot:cell(updated_at)="data">
                <span v-text="data.item.data.attributes.updated_at"/>
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        name: "LatestAdmissions",
        props: ['data'],
        data() {
            return {
                bootstrapTable: {
                    fields: [
                        {key: 'code', label: 'Code', tdClass: ''},
                        {key: 'client_id', label: 'Client', tdClass: ''},
                        {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                        {key: 'unit', label: 'Unit', tdClass: 'text-muted'},
                        {key: 'move_in', label: 'Move In', tdClass: 'text-muted'},
                        {key: 'updated_by', label: 'Updated By', tdClass: 'text-muted'},
                        {key: 'updated_at', label: 'Updated At', tdClass: 'text-muted'},
                    ]
                }
            }
        },
    }
</script>

<style scoped>

</style>
